import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private modelsDataSubject = new BehaviorSubject<any>(null); // Para compartir datos entre componentes
  modelData$ = this.modelsDataSubject.asObservable();
  modelos$= new EventEmitter<any>();

  constructor(private http: HttpClient) {}

  getCategorias(tipo:any) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const url = `${environment.apiUrl}/api/v1/vehiculos/${tipo}`;
      return this.http.get<any>(url, httpOptions)
  }
  getCategoriasModels(categoria:any) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const url = `${environment.apiUrl}/api/v1/yamaha/${categoria}/all`;
      return this.http.get<any>(url, httpOptions)
  }

  getModelos(marca:any, modelo:any) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const url = `${environment.apiUrl}/api/v1/${marca}/motos/subcategorias/${modelo}/caracteristicas`;
      return this.http.get<any>(url, httpOptions)
    }

  //unicamente para menú
  fetchMenuData(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    //agregar v2
    const url = `${environment.apiUrl}/api/v1/yamaha/motos/all`;
    return this.http.get<any>(url, httpOptions);
  }

  // Método para cargar y distribuir los datos
  loadMenuData() {
    this.fetchMenuData().subscribe((data:any) => {
      this.modelsDataSubject.next(data); // Actualiza los datos compartidos
    });
  }
}
